export { TickTockService } from './services';
export { TickTockComponent, PComponent, H1Component } from './components';
export { TickTockModule } from './tick-tock.module';
export { MicroComponentModule } from './micro-component.module';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/index.ts